import{ React, useState, useEffect, LoaderOverlay, withAuth, toast,connect, useDispatch, useSelector,useNavigate, MESSAGES,useParams } from './../../common/helper/common-imports.component.js';
import SelectSearch from 'react-select-search';
import { agentsList } from "./../../../actions/agent-actions.js";
import MerchantsService from "../../../services/merchants-service.js";
import FundsService from '../../../services/funds-service.js';
import { initialFormData, initialErrors, fieldValidation  } from '../../common/helper/form-constants.js';
import ConfigService from '../../../services/config-service.js';
import { useUserPermissionData } from '../../../services/perm-service.js';

const Funds = () => { 
  const userData = useSelector(state => state.authReducer);
  const canTransferAgent = useUserPermissionData('fund_transfer_agent');
  const canTransferMerchant = useUserPermissionData('fund_transfer_merchant');
  const canTransferDistributor = useUserPermissionData('fund_transfer_distributor');
  const firstTab = canTransferAgent ? 'agent' : canTransferMerchant ? 'merchant' : canTransferDistributor ? 'distributor' : null;
  const [distributors,setDistributors]  = useState([]);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [agents, setAgents] = useState([]);
  const [merchants, setMerchants] = useState([]);
  const [errors, setErrors] = useState({ ...initialErrors });
  const [formData, setFormData] = useState({toAgent: '', amountAgent: '', remarkAgent: ''})
  const [formDataMerchant, setFormDataMerchant] = useState({toMerchant: '', amountMerchant: '', remarkMerchant: ''})
  const [formDataDistributor, setFormDataDistributor] = useState({toDistributor: '', amountDistributor: '', remarkDistributor: ''})

  const getAgents = () => {
    setLoading(true);
    dispatch(agentsList())
    .then((response) => {
      const agents = response.data.Active
      const arr = [];
      for(var i=0; i<agents.length; i++) {
        arr.push({
          name: agents[i].full_name + ' ('+agents[i].agent_id+')',
          value: agents[i].user_id,
        })
      }
      console.log(arr);
      setAgents(arr);
      setLoading(false);
    })
    .catch((error) => {
      setLoading(false);
    });
   
  }
  
  const getMerchantsList = (e) => {
    setLoading(true);
    MerchantsService.getMerchants()
      .then(response => {
        const merchts = response.data.data;
        const arr = [];
        for(var i=0; i<merchts.length; i++) {
          if(merchts[i].merchant_detail.status_id == 'A') {
            arr.push({
              name: merchts[i].merchant_detail.merchant_name,
              value: merchts[i].merchant_detail.merchant_id,
            })
          }
          
        }
        setMerchants(arr);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        console.error("Error fetching agents:", error);
      });
  }

  const getDistributors = () => {
    setLoading(true);
    ConfigService.getDistributorDropDown()
    .then((response) => {
      const arr = [];
      const dis = response.data.data
      for(var i=0; i<dis.length; i++) {
        arr.push({
          name: dis[i].value,
          value: dis[i].key,
        })
      }
      console.log(arr);
      setDistributors(arr);
      setLoading(false);
    })
    .catch((error) => {
      console.log(error)
      setLoading(false);
    });
   
  }
  const validateField = (fieldName, value) => {
    const errorMessage = fieldValidation(fieldName, value);
    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: errorMessage }));
    return errorMessage
  };
  
  const handleChangeSearch = (e) => {
    setFormData((prevData) => ({ ...prevData, ['toAgent']: e }));
    setErrors((prevErrors) => ({ ...prevErrors, ['toAgent']: '' }));
  }
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    validateField(name, value);
  };

  const handleChangeSearchMerchant = (e) => {
    setFormDataMerchant((prevData) => ({ ...prevData, ['toMerchant']: e }));
    setErrors((prevErrors) => ({ ...prevErrors, ['toMerchant']: '' }));
   // validateField('toAgent', e);
  }
  const handleChangeMerchant = (e) => {
    const { name, value } = e.target;
    setFormDataMerchant((prevData) => ({ ...prevData, [name]: value }));
    validateField(name, value);
  };
  const handleChangeSearchDistributor = (e) => {
    setFormDataDistributor((prevData) => ({ ...prevData, ['toDistributor']: e }));
    setErrors((prevErrors) => ({ ...prevErrors, ['toDistributor']: '' }));
   // validateField('toAgent', e);
  }
  const handleChangeDistributor = (e) => {
    const { name, value } = e.target;
    setFormDataDistributor((prevData) => ({ ...prevData, [name]: value }));
    validateField(name, value);
  };

  const fundAgent = (e) => {
    e.preventDefault();
    let hasErrors;
    Object.keys(formData).forEach(fieldName => {
      const error = validateField(fieldName, formData[fieldName]);
      if (error) {
          hasErrors = true;
      }
  });
  if(!hasErrors) {
    setLoading(true);
    const data = {
      transfer_amount: formData.amountAgent,
      funder_type:'AGENT',
      funder_id:formData.toAgent,
      remarks: formData.remarkAgent
    }
    FundsService.depositFund(data)
      .then(response => {
        toast.success(MESSAGES.FUND_DEPOSIT);
        setLoading(false);
        setFormData({
          toAgent: '',
          amountAgent: '',
          remarkAgent: '',
         
        });

      })
      .catch(error => {
        const errorMessage = error.response.data
        toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
        setLoading(false);
       
      });
    }

  }

  const fundMerchant = (e) => {
    e.preventDefault();
    let hasErrors;
    Object.keys(formDataMerchant).forEach(fieldName => {
      const error = validateField(fieldName, formDataMerchant[fieldName]);
      if (error) {
          hasErrors = true;
      }
  });

  if(!hasErrors) {
    setLoading(true);
    const data = {
      transfer_amount: formDataMerchant.amountMerchant,
      funder_type:'MERCHANT',
      funder_id:formDataMerchant.toMerchant,
      remarks: formDataMerchant.remarkMerchant
    }
    FundsService.depositFund(data)
      .then(response => {
        toast.success(MESSAGES.FUND_DEPOSIT);
        setLoading(false);
        setFormDataMerchant({amountMerchant:'',toMerchant:'',remarkMerchant:''});
      })
      .catch(error => {
        const errorMessage = error.response.data
        toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
        setLoading(false);
       
      });
    }
  }

  
  const fundDistributor = (e) => {
    e.preventDefault();
    let hasErrors;
    Object.keys(formDataDistributor).forEach(fieldName => {
      const error = validateField(fieldName, formDataDistributor[fieldName]);
      if (error) {
          hasErrors = true;
      }
  });

  if(!hasErrors) {
    setLoading(true);
    const data = {
      transfer_amount: formDataDistributor.amountDistributor,
      funder_type:'DISTRIBUTOR',
      funder_id:formDataDistributor.toDistributor,
      remarks: formDataDistributor.remarkDistributor
    }
    FundsService.depositFund(data)
      .then(response => {
        toast.success(MESSAGES.FUND_DEPOSIT);
        setLoading(false);
        setFormDataMerchant({amountDistributor:'',toDistributor:'',remarkDistributor:''});
      })
      .catch(error => {
        const errorMessage = error.response.data
        toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
        setLoading(false);
       
      });
    }
  }


    const options = [
        {name: 'Swedish', value: 'sv'},
        {name: 'English', value: 'en'},
    ];

    useEffect(() => {
      getAgents();
      getMerchantsList();
      getDistributors();
      document.body.style.backgroundImage = '';

        document.body.style.backgroundColor = '#f0f6fa';
        return () => {
          document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
        };
    }, []);
    return(
      <div>
          <LoaderOverlay loading={loading} />
  
        <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
        <h4 className="updatename updatename2" style={{marginTop: 0, fontWeight: 700, fontSize: '16px'}}>Funds</h4>
        <div className="container" style={{backgroundColor: 'white'}}>
          <nav>
            <div className="nav nav-tabs" id="nav-tab" role="tablist">
              {canTransferAgent && (
              <button className={`nav-link tbbtn ${firstTab === 'agent' ? 'active' : ''}`} id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected={firstTab === 'agent'}>Agent Deposit</button>
              )}
              {canTransferMerchant && (
              <button className={`nav-link tbbtn ${firstTab === 'merchant' ? 'active' : ''}`} id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected={firstTab === 'merchant'}>Merchant Deposit</button>
              )}
              {canTransferDistributor && (
              <button className={`nav-link tbbtn ${firstTab === 'distributor' ? 'active' : ''}`} id="nav-distributor-tab" data-bs-toggle="tab" data-bs-target="#nav-distributor" type="button" role="tab" aria-controls="nav-distributor" aria-selected={firstTab === 'distributor'}>Distributor Deposit</button>
              )}
            </div>
          </nav>
          <div className="tab-content" id="nav-tabContent" style={{paddingTop: '15px'}}>
            {canTransferAgent && (
            <div className={`tab-pane fade ${firstTab === 'agent' ? 'show active' : ''}`} id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
              <form method="post" onSubmit={fundAgent}>
              <div className="panel panel-default">
                <div className="panel-body" style={{padding: '0px'}}>
                  <div className="col-md-12" style={{padding: 0}}>
                    <div className="col-md-5" style={{padding: '0px', paddingRight: '30px'}}>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label className="required" htmlFor="Transaction">FROM</label>
                       
                        <SelectSearch search={true} options={options} disabled={true} name="language" placeholder={userData.user.data.role.role_code == 'DADMIN' ? userData.user.data.full_name : "XXXXX-POOL-ACCOUNT-XXXXXX"} />
                        
                        <span id="error_pull_account" className="text-danger" />
                      </div>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label className="required" htmlFor="to">TO</label>
                        <div className={`${errors.toAgent ? 'is-invalid-search' : ''}`}>
                        <SelectSearch  value={formData.toAgent}  search={true} options={agents} onChange={handleChangeSearch} name="toAgent" placeholder="Choose Agent" />
                        <span class="fa fa-angle-down errspan"></span>
                        </div>
                        {errors.toAgent && <div style={{color:'#dc3545',fontSize: '0.875em',marginTop: '0.25rem'}}>{errors.toAgent}</div>}
                       
                      </div>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label className="required" htmlFor="confirm_password">AMOUNT</label>
                        <input type="number"  value={formData.amountAgent} className={`form-control ${errors.amountAgent ? 'is-invalid' : ''}`} id="to_amount" placeholder="Enter Your Amount" name="amountAgent" onChange={handleChange} />
                        {errors.amountAgent && <div className="invalid-feedback">{errors.amountAgent}</div>}
                      </div>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label htmlFor="confirm_password">REMARK</label>
                        <input type="text" className="form-control nhjgf" onChange={handleChange} id="profile_conpass" value={formData.remarkAgent} placeholder="Enter Remark" name="remarkAgent" />
                      </div>
                    </div>
                  </div>
                  <br />
                  <div align="left">
                    <button type="submit" name="btn_chngepass" id="btn_agentfunds" className="btn ddfg sebtn">Submit</button>
                  </div>
                  <br />
                </div>
              </div>
              </form>
            </div>
            )}
            {canTransferMerchant && (
            <div className={`tab-pane fade ${firstTab === 'merchant' ? 'show active' : ''}`} id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
              <form method="post" onSubmit={fundMerchant}>
              <div className="panel panel-default">
                <div className="panel-body" style={{padding: '0px'}}>
                  <div className="col-md-12" style={{padding: 0}}>
                    <div className="col-md-5" style={{padding: '0px', paddingRight: '30px'}}>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label className="required" htmlFor="Transaction">FROM</label>
                        <SelectSearch search={true} options={options} disabled={true} name="language"  placeholder={userData.user.data.role.role_code == 'DADMIN' ? userData.user.data.full_name : "XXXXX-POOL-ACCOUNT-XXXXXX"} />
                        <span class="fa fa-angle-down errspan"></span>
                      </div>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label className="required" htmlFor="to">TO</label>
                        <div className={`${errors.toMerchant ? 'is-invalid-search' : ''}`}>
                        <SelectSearch search={true} options={merchants} onChange={handleChangeSearchMerchant}  value={formDataMerchant.toMerchant} name="toMerchant" placeholder="Choose Merchant" />
                        <span class="fa fa-angle-down errspan"></span>
                        {errors.toMerchant && <div style={{color:'#dc3545',fontSize: '0.875em',marginTop: '0.25rem'}}>{errors.toMerchant}</div>}
                        </div>
                        <span id="error_to_accounts" className="text-danger" />
                      </div>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label className="required" htmlFor="confirm_password">AMOUNT</label>
                        <input type="number"  value={formDataMerchant.amountMerchant} className={`form-control ${errors.amountMerchant ? 'is-invalid' : ''}`}  onChange={handleChangeMerchant} id="to_amounts" placeholder="Enter Your Amount" name="amountMerchant"/>
                        {errors.amountMerchant && <div className="invalid-feedback">{errors.amountMerchant}</div>}
                      </div>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label htmlFor="confirm_password">REMARK</label>
                        <input type="text" className="form-control nhjgf" id="profile_conpass" placeholder="Enter Remark" value={formDataMerchant.remarkMerchant} onChange={handleChangeMerchant} name ="remarkMerchant"/>
                      </div>
                    </div>
                  </div>
                  <br />
                  <div align="left">
                    <button type="submit" name="btn_chngepass" id="btn_merchantsfunds" className="btn ddfg sebtn">Submit</button>
                  </div>
                  <br />
                </div>
              </div>
              </form>
            </div>
            )}
            {canTransferDistributor && (
            <div className={`tab-pane fade ${firstTab === 'distributor' ? 'show active' : ''}`} id="nav-distributor" role="tabpanel" aria-labelledby="nav-distributor-tab">
              <form method="post" onSubmit={fundDistributor}>
              <div className="panel panel-default">
                <div className="panel-body" style={{padding: '0px'}}>
                  <div className="col-md-12" style={{padding: 0}}>
                    <div className="col-md-5" style={{padding: '0px', paddingRight: '30px'}}>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label className="required" htmlFor="Transaction">FROM</label>
                        <SelectSearch search={true} options={options} disabled={true} name="language"  placeholder={userData.user.data.role.role_code == 'DADMIN' ? userData.user.data.full_name : "XXXXX-POOL-ACCOUNT-XXXXXX"} />
                        <span class="fa fa-angle-down errspan"></span>
                      </div>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label className="required" htmlFor="to">TO</label>
                        <div className={`${errors.toDistributor ? 'is-invalid-search' : ''}`}>
                        <SelectSearch search={true} options={distributors} onChange={handleChangeSearchDistributor}  value={formDataDistributor.toDistributor} name="toDistributor" placeholder="Choose Distributor" />
                        <span class="fa fa-angle-down errspan"></span>
                        {errors.toDistributor && <div style={{color:'#dc3545',fontSize: '0.875em',marginTop: '0.25rem'}}>{errors.toDistributor}</div>}
                        </div>
                        <span id="error_to_accounts" className="text-danger" />
                      </div>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label className="required" htmlFor="confirm_password">AMOUNT</label>
                        <input type="number"  value={formDataDistributor.amountDistributor} className={`form-control ${errors.amountDistributor ? 'is-invalid' : ''}`}  onChange={handleChangeDistributor} id="to_amounts" placeholder="Enter Your Amount" name="amountDistributor"/>
                        {errors.amountDistributor && <div className="invalid-feedback">{errors.amountDistributor}</div>}
                      </div>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label htmlFor="confirm_password">REMARK</label>
                        <input type="text" className="form-control nhjgf" id="profile_conpass" placeholder="Enter Remark" value={formDataDistributor.remarkMerchant} onChange={handleChangeDistributor} name ="remarkMerchant"/>
                      </div>
                    </div>
                  </div>
                  <br />
                  <div align="left">
                    <button type="submit" name="btn_chngepass" id="btn_merchantsfunds" className="btn ddfg sebtn">Submit</button>
                  </div>
                  <br />
                </div>
              </div>
              </form>
            </div>
            )}
          </div>
        </div>
      </div>
      </div>
    )
}

function mapStateToProps(state) {
    const userData = state.authReducer.user;
    return { userData };
  }
export default withAuth(connect(mapStateToProps)(Funds));